import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../../lib/api";
import SEOMeta from "../../components/SEOMeta";

const GoogleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M21.6 12.23c0-.68-.06-1.36-.19-2.02H12v3.83h5.4a4.62 4.62 0 0 1-2 3.03v2.52h3.24c1.9-1.75 2.96-4.32 2.96-7.36Z" fill="#D4AF37" />
    <path d="M12 22c2.7 0 4.96-.9 6.62-2.42l-3.24-2.52c-.9.6-2.05.96-3.38.96-2.6 0-4.8-1.76-5.58-4.12H3.08v2.6A10 10 0 0 0 12 22Z" fill="#F5D67B" />
    <path d="M6.42 13.9a6 6 0 0 1 0-3.8V7.5H3.08a10 10 0 0 0 0 9l3.34-2.6Z" fill="#B8962E" />
    <path d="M12 5.98c1.47 0 2.79.5 3.82 1.5l2.87-2.87A10 10 0 0 0 3.08 7.5l3.34 2.6C7.2 7.74 9.4 5.98 12 5.98Z" fill="#E8C96A" />
  </svg>
);

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const notAdmin = location.state?.error === "not_admin";

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => {
        if (r.data.is_admin) navigate("/admin", { state: { user: r.data }, replace: true });
        else setChecking(false);
      })
      .catch(() => setChecking(false));
  }, [navigate]);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-6 relative overflow-hidden">
      <SEOMeta title="Admin | Touson Ventures" description="Admin console for Touson Ventures." />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.07),transparent_60%)]" />
      <div className="relative w-full max-w-md border border-white/10 bg-white/[0.03] backdrop-blur-xl p-10 sm:p-14" data-testid="admin-login-card">
        <div className="flex items-baseline gap-2 mb-3">
          <span className="font-display text-2xl tracking-tight text-white">
            Touson<span className="text-gold">.</span>
          </span>
          <span className="font-mono text-[10px] tracking-[0.35em] text-white/50">VENTURES</span>
        </div>
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold mb-10">Admin Console</p>
        {notAdmin && (
          <p className="mb-6 text-sm text-red-400 border border-red-400/30 bg-red-400/10 px-4 py-3 rounded-md" data-testid="admin-login-error">
            This Google account does not have admin access.
          </p>
        )}
        <p className="text-sm text-white/55 leading-relaxed mb-8">
          Sign in with your authorized Google account to manage businesses, content and enquiries.
        </p>
        <button
          onClick={handleGoogleLogin}
          disabled={checking}
          data-testid="admin-google-login-button"
          className="w-full inline-flex items-center justify-center gap-3 bg-gold text-navy font-medium text-sm px-6 py-4 rounded-full hover:bg-gold-light transition-colors duration-300 disabled:opacity-50"
        >
          <GoogleIcon /> Continue with Google
        </button>
        <a
          href="/"
          data-testid="admin-back-home-link"
          className="mt-6 block text-center font-mono text-[11px] tracking-[0.25em] uppercase text-white/40 hover:text-gold transition-colors duration-300"
        >
          Back to Website
        </a>
      </div>
    </div>
  );
}
